import { ProxyRaw, RawNode } from './environment';
import { concat } from './concat';
export var buildDataTree = function (target, key, value) {
    var raw = ProxyRaw.get(value) || value;
    var currentNode = RawNode.get(raw);
    if (currentNode)
        return currentNode;
    var parentRaw = ProxyRaw.get(target) || target;
    var parentNode = RawNode.get(parentRaw);
    if (parentNode) {
        RawNode.set(value, {
            get path() {
                return concat(parentNode.path, key);
            },
            parent: parentNode,
            observers: [],
            deepObservers: [],
        });
    }
    else {
        RawNode.set(value, {
            path: [],
            observers: [],
            deepObservers: [],
        });
    }
};
